<!-- @format -->

<ng-container *transloco="let t">
  @if (attainment | attainmentName | async | localizedString; as attainmentName) {
    <div class="modal-header">
      <h2 id="attainment-details-heading">{{ attainmentName }}, {{ attainment | attainmentCode | async }}</h2>
      <button type="button" class="modal-close" (click)="modal.dismiss()" [attr.aria-label]="t('ARIA_LABEL.CLOSE')">
        <sis-icon icon="ring-close"></sis-icon>
      </button>
    </div>
    @if (!attainment.primary) {
      <sis-contextual-notification variant="warning" class="form-group">
        <div>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.SECONDARY_ATTAINMENT_NOTIFICATION") }}</div>
      </sis-contextual-notification>
    }
    @if (externallyImportedDPAttainment) {
      <sis-contextual-notification variant="danger" class="form-group">
        <div>{{ t("ATTAINMENTS.ATTAINMENT_DETAILS.DEGREE_PROGRAM_ATTAINMENT_EXTERNAL_EVALUATION_WARNING") }}</div>
      </sis-contextual-notification>
    }
    @if (attainment.misregistration) {
      <sis-contextual-notification variant="danger" class="form-group">
        <p>
          {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.MISREGISTRATION_NOTIFICATION") }}
        </p>
        <p>
          {{ t("ATTAINMENTS.ATTAINMENT_DETAILS.MISREGISTRATION_RATIONALE") }}:
          {{ attainment.misregistrationRationale }}
        </p>
      </sis-contextual-notification>
    }
    <div class="modal-body">
      @if (attainment.type === "DegreeProgrammeAttainment") {
        <sis-degree-programme-attainment-details [attainment]="$any(attainment)" [expirationImminent]="expirationImminent">
        </sis-degree-programme-attainment-details>
      }
      @if (attainment.type === "ModuleAttainment") {
        <sis-module-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </sis-module-attainment-details>
      }
      @if (attainment.type === "CustomModuleAttainment") {
        <sis-custom-module-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </sis-custom-module-attainment-details>
      }
      @if (attainment.type === "CourseUnitAttainment") {
        <sis-course-unit-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </sis-course-unit-attainment-details>
      }
      @if (attainment.type === "CustomCourseUnitAttainment") {
        <sis-custom-course-unit-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent">
        </sis-custom-course-unit-attainment-details>
      }
      @if (attainment.type === "AssessmentItemAttainment") {
        <sis-assessment-item-attainment-details
          [attainment]="$any(attainment)"
          [secondaryAttainments]="secondaryAttainments"
          [expirationImminent]="expirationImminent"
          >>
        </sis-assessment-item-attainment-details>
      }
    </div>
    <div class="modal-footer">
      <sis-button (clicked)="modal.dismiss()">{{ t("COMMON.CLOSE") }}</sis-button>
    </div>
  }
</ng-container>
